import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg5 from "../../assets/img/5.png";
import projectimage5 from "../../assets/img/p5.png";

const PreviousCard5 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Dynamic clustering of log anomalies</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage5} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg5} />{" "}
            <p className="text7">Miklós Telek </p>
            <br />
            <p className="text8">
              Professor <br /> Department of Networked Systems and
              Services, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The aim of the project is to develop a technique for
              identifying patterns in log data by dynamically clustering
              log anomalies in real-time. This method involves applying
              unsupervised machine learning algorithms to the real-time
              evolving data, which automatically group similar log
              anomalies together into clusters. By analyzing the patterns
              within these clusters, the method can identify potential
              issues or anomalies in the system and provide insights for
              optimization or troubleshooting. The approach is useful for
              monitoring large-scale distributed systems, such as those
              used in cloud computing or IoT devices, and can help improve
              system performance, reliability, and security.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Landauer, M., Wurzenberger, M., Skopik, F., Settanni,
                  G., & Filzmoser, P. (2018). Dynamic log file analysis:
                  An unsupervised cluster evolution approach for anomaly
                  detection.{" "}
                  <span className="text9"> Computers & Security </span>, 79,
                  94-116.
                </li>
                <li>
                  Christensen, R., & Li, F. (2013, June). Adaptive log
                  compression for massive log data.
                  <span className="text9"> In SIGMOD Conference </span> (pp.
                  1283-1284).{" "}
                </li>
                <li>
                  He, S., He, P., Chen, Z., Yang, T., Su, Y., & Lyu, M. R.
                  (2021). A survey on automated log analysis for
                  reliability engineering.
                  <span className="text9"> ACM computing surveys (CSUR) </span>,
                  54(6), 1-37.
                </li>
                <li>
                  Landauer, M., Skopik, F., Wurzenberger, M., & Rauber, A.
                  (2020). System log clustering approaches for cyber
                  security applications: A survey.
                  <span className="text9"> Computers & Security </span>, 92,
                  101739.
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard5;
